import { handleError } from "api/helper";
import { request } from "api/http";
import { UploadedImageResponse } from "./UploadedImageResponse";

export const uploadMedia = async (
  file: File,
  type: "image" | "video"
): Promise<UploadedImageResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "customer_upload");

  return request("POST", false)(
    `https://api.cloudinary.com/v1_1/www-adfenix-com/${type}/upload`,
    formData
  ).catch(handleError);
};
